import { Box, BoxProps } from "@mui/material";
import { useTheme } from "contexts";

type Props = BoxProps & {};

export const Divider = ({ color, ...props }: Props) => {
  const { theme } = useTheme();

  return (
    <Box
      component="div"
      height="1px"
      my={theme.spacing.xl}
      bgcolor={theme.color.primary.accent}
      {...props}
    />
  );
};
